<div class="hidden">
  {{url.useGet ? 'GET' : 'POST' }}: {{url.logoutUrl}}
</div>
